import { splitToken } from 'dibs-cookie-jar/exports/splitToken';

let guestUserToken: string | undefined;

export function getGuestUserToken(): string | undefined {
    return guestUserToken;
}

export function getGuestUserId(): string | null {
    if (guestUserToken) {
        return splitToken(guestUserToken);
    }
    return null;
}

export function setGuestUserToken(token: string | null): void {
    if (token) {
        guestUserToken = token;
    } else {
        guestUserToken = undefined;
    }
}
